import React from 'react';
import Icon from '../muiComponents/Icon';

interface IStatusCellProps {
    text?: string;
    color?: string;
    iconStyle?: React.CSSProperties;
    className?: string;
}

const Status = ({ text, color, iconStyle, className }: IStatusCellProps) => {
    return (
        <span
            className={`flex flex-align-center gap-5 font-size-14 width-content ${className}`}
        >
            <Icon
                iconName='FiberManualRecord'
                style={{
                    color,
                    fontSize: '14px',
                    ...iconStyle,
                }}
            />
            {text && <p> {text}</p>}
        </span>
    );
};

export default Status;
